uniform vec3 topColor;
uniform vec3 bottomColor;
uniform float exponent;

varying vec3 vWorldPosition;

void main() {
    // Calculate normalized vertical position of the fragment
    float h = normalize(vWorldPosition).y * 0.5 + 0.5;  // Normalize vWorldPosition and adjust range to [0, 1]

    // Mix colors based on the gradient height and exponent
    vec3 gradientColor = mix(bottomColor, topColor, pow(h, exponent));

    gl_FragColor = vec4(gradientColor, 1.0);
}
